// // // //
// Measure Types

export enum MeasureUnit {
    year = "year",
    x = "x",
    transfers = "transfers",
    trades = "trades",
    token = "token",
    shares = "shares",
    ratio = "ratio",
    percent = "percent",
    loan = "loan",
    id = "id",
    enum = "enum",
    dollar = "dollar",
    address = "address",
}

export type TimeseriesWindow =
    "daily" | "weekly" | "monthly" | "quarterly" | "yearly";

export interface Measure {
    id: number;
    slug: string;
    name: string;
    display_name: string;
    short_description?: string | null;
    description: string | null;
    category: string | null;
    category_order: number;
    featured: boolean;
    item_order: number;
    icon: string;
    color: string;
    icon_url: string | null;
    documentation_url: string | null;
    unit: MeasureUnit;
    timeseries_window: TimeseriesWindow;
    has_asset_snapshots: boolean;
    has_token_snapshots: boolean;
    asset_count: number;
    asset_ids: string;
    token_count: number;
    token_ids: string;
    network_count: number;
    network_ids: string;
    platform_count: number;
    platform_ids: string;
    asset_class_count: number;
    asset_class_ids: string;
    manager_count: number;
    manager_ids: string;
    jurisdiction_count: number;
    jurisdiction_ids: string;
}

// // // //
// Measure Column Enum

export enum MeasureColumns {
    id = "id",
    slug = "slug",
    name = "name",
    displayName = "display_name",
    shortDescription = "short_description",
    description = "description",
    category = "category",
    hidden = "hidden",
    iconUrl = "icon_url",
    documentationUrl = "documentation_url",
    unit = "unit",
    hasAssetSnapshots = "has_asset_snapshots",
    hasTokenSnapshots = "has_token_snapshots",
    assetCount = "asset_count",
    assetIDs = "asset_ids",
    tokenCount = "token_count",
    tokenIDs = "token_ids",
    networkCount = "network_count",
    networkIDs = "network_ids",
    platformCount = "platform_count",
    platformIDs = "platform_ids",
    assetClassCount = "asset_class_count",
    assetClassIDs = "asset_class_ids",
    managerCount = "manager_count",
    managerIDs = "manager_ids",
    jurisdictionCount = "jurisdiction_count",
    jurisdictionIDs = "jurisdiction_ids",
}
